/* assets/sonuuu-countdown.js — ES5 safe, no arrows, no optional chaining */
(function () {
  if (window.SonuuuCountdown && window.SonuuuCountdown._ready) {
    // rebind in case of PJAX/SPA navigations
    try { window.SonuuuCountdown.bindAll(); } catch(e) {}
    return;
  }

  window.SonuuuCountdown = {
    _ready: true,
    bound: {},
    fmt: function(n){ return (n < 10 ? '0' : '') + n; },
    safeGet: function(k){ try { return localStorage.getItem(k); } catch(e){ return null; } },
    safeSet: function(k,v){ try { localStorage.setItem(k, v); } catch(e){} },

    getStart: function(key){
      var v = this.safeGet(key);
      if (v) {
        var n = parseInt(v, 10);
        if (!isNaN(n)) return n;
      }
      var now = Date.now();
      this.safeSet(key, String(now));
      return now;
    },

    bindOne: function(root){
      if (!root || root.nodeType !== 1) return;
      var id = root.getAttribute('data-sec');
      if (!id || this.bound[id]) return;

      var days = parseInt(root.getAttribute('data-cycle-days'), 10);
      if (!(days > 0)) days = 2;

      var timerEl = root.querySelector('[data-sonuuu-timer]');
      if (!timerEl) return;

      var self = this;
      var key = 'sonuuu-countdown-start-' + id;

      function endFrom(start){ return start + days * 86400000; }
      function tick(){
        var start = self.getStart(key);
        var end = endFrom(start);
        var now = Date.now();

        if (now >= end) {
          self.safeSet(key, String(now));
          end = endFrom(now);
        }

        var total = Math.max(0, Math.floor((end - now) / 1000));
        var d = Math.floor(total / 86400);
        var h = Math.floor((total % 86400) / 3600);
        var m = Math.floor((total % 3600) / 60);
        var s = total % 60;

        timerEl.textContent = (d > 0 ? (self.fmt(d) + 'd : ') : '') + self.fmt(h) + 'h : ' + self.fmt(m) + 'm : ' + self.fmt(s) + 's';
        timerEl.setAttribute('aria-label', (d > 0 ? (d + ' days, ') : '') + h + ' hours, ' + m + ' minutes, ' + s + ' seconds left');
      }

      tick();
      setInterval(tick, 1000);
      this.bound[id] = true;
    },

    bindAll: function(){
      var nodes = document.querySelectorAll('[data-sonuuu-offer]');
      for (var i = 0; i < nodes.length; i++) {
        this.bindOne(nodes[i]);
      }
    },

    startObserver: function(){
      if (this._obs) return;
      var self = this;
      this._obs = new MutationObserver(function(muts){
        for (var i=0; i<muts.length; i++){
          var m = muts[i];
          if (m.addedNodes) {
            for (var j=0; j<m.addedNodes.length; j++){
              var n = m.addedNodes[j];
              if (!n || n.nodeType !== 1) continue;
              if (n.matches && n.matches('[data-sonuuu-offer]')) self.bindOne(n);
              var found = n.querySelectorAll ? n.querySelectorAll('[data-sonuuu-offer]') : [];
              for (var k=0; k<found.length; k++) self.bindOne(found[k]);
            }
          }
        }
      });
      this._obs.observe(document.documentElement, { childList: true, subtree: true });
    },

    init: function(){
      try { this.bindAll(); } catch(e){}
      try { this.startObserver(); } catch(e){}
    }
  };

  function onReady(){
    window.SonuuuCountdown.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
  // also bind on load (some themes hydrate after DOMContentLoaded)
  window.addEventListener('load', onReady);
  // Shopify editor events
  document.addEventListener('shopify:section:load', onReady);
  document.addEventListener('shopify:section:unload', onReady);
  // History/pjax fallback
  window.addEventListener('pageshow', onReady);
})();
